import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/variables.css';
import './styles/base.css';
import './styles/theme-dark.css'; /* Samurai Theme */
/* import './styles/theme.css'; Remove legacy theme */
import './styles/typography.css';
import './styles/layout.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();